import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import DateRangeIcon from '@mui/icons-material/DateRange';
import {
  Box,
  Button,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import React from 'react';
import {
  captionText,
  containerBox,
  getToggleButtonGroupStyles,
} from './styles';

interface TimelinePeriodSelectorProps {
  lookbackPeriod: string;
  onPeriodChange: (period: string) => void;
  onCustomRangeClick: () => void;
  isLightTheme: boolean;
}

const TimelinePeriodSelector: React.FC<TimelinePeriodSelectorProps> = ({
  lookbackPeriod,
  onPeriodChange,
  onCustomRangeClick,
  isLightTheme,
}) => {
  return (
    <Box sx={containerBox}>
      <Typography variant='caption' sx={captionText}>
        <FormattedAlias id='Select Time Period' />
      </Typography>
      <Stack direction='row' spacing={1}>
        <ToggleButtonGroup
          value={lookbackPeriod}
          exclusive
          onChange={(_, value) => {
            if (value !== null) {
              onPeriodChange(value);
            }
          }}
          size='small'
          color='primary'
          sx={getToggleButtonGroupStyles(isLightTheme)}
        >
          <ToggleButton value='-1m'>
            <FormattedAlias id='1m' />
          </ToggleButton>
          <ToggleButton value='-15m'>
            <FormattedAlias id='15m' />
          </ToggleButton>
          <ToggleButton value='-1h'>
            <FormattedAlias id='1h' />
          </ToggleButton>
          <ToggleButton value='-6h'>
            <FormattedAlias id='6h' />
          </ToggleButton>
          <ToggleButton value='-12h'>
            <FormattedAlias id='12h' />
          </ToggleButton>
          <ToggleButton value='-24h'>
            <FormattedAlias id='24h' />
          </ToggleButton>
          <ToggleButton value='-48h'>
            <FormattedAlias id='48h' />
          </ToggleButton>
        </ToggleButtonGroup>

        <Button
          variant='outlined'
          color='primary'
          size='small'
          startIcon={<DateRangeIcon />}
          onClick={onCustomRangeClick}
        >
          <FormattedAlias id='Custom Range' />
        </Button>
      </Stack>
    </Box>
  );
};

TimelinePeriodSelector.displayName = 'TimelinePeriodSelector';

export default TimelinePeriodSelector;
